import React from "react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GetAllOrderApi from "../../../api/allOrderApi";
import {
  SETALLORDERDATA,
  SETORDERDETAIL,
} from "../../../redux/features/AllOrder";
import AddOnCalculate from "../../../utils/AddOn";
import { OrderStatusType } from "../../../utils/OrderStatusType";
import ParseFloat from "../../../utils/ParseFloat";
import CurrentOrderSkelton from "./CurrentOrderSkelton";
import NoOrderFound from "./NoOrderFound";
import AllReview from "../../Review/AllReview";
import { reviewRefrencePageArr } from "../../Review/AllReview";
import Konsole from "../../../utils/konsole/Konsole";
import StoreDescription from "../../Store/Store-Description";
import { ItemSizeNameForOrder } from "../../../utils/ItemSizeName";
import { CheckIsMeal } from "../../../utils/CustomizedCalculation/MealPrice";
import { ReturnStoreAddress } from "../../../utils/helper";
import OrderStoreInfo from "../../OrderDetail/OrderStoreInfo";
import { TotalPriceOfMealItem } from "../../../utils/orderUtils/OrderUtils";

export default function CurrentOrder() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orders } = useSelector((state: any) => state?.allOrder);
  const [loading, setLoading] = useState(false);
  const [isNumber, setIsNumber] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (!orders.length) {
      getOrder();
    }
  }, []);
  async function getOrder() {
    setLoading(true);
    const { order_list } = await GetAllOrderApi();

    Konsole.log("order_list", order_list);
    dispatch(SETALLORDERDATA(order_list));
    setLoading(false);
  }

  const handleOrderDetail = (item: any) => {
    dispatch(SETORDERDETAIL(item));
    navigate(`/order-detail/${item.order_id}`);
  };

  Konsole.log("ordersorders", orders);
  return (
    <>
      <div className="mb-3">
        {loading ? (
          <CurrentOrderSkelton />
        ) : orders && orders?.length > 0 ? (
          orders.map((order: any) => (
            <div className="md:border border-b border-[#D7D7D7] md:rounded-lg overflow-hidden mb-3" key={order.order_id} >

              {/* @@ Order Store Details */}
              <div className="md:bg-[#F8F8F8] py-2 px-4 cursor-pointer" onClick={() => handleOrderDetail(order)} >
                <OrderStoreInfo orderDetail={order} refrencePage="CurrentOrder" />
              </div>

              {/* @@ Order Information */}
              <div className="py-2 px-4">
                {order?.orderlist?.map((item: any) => {

                  // console.log("itemitemitem", item)
                  let addons = AddOnCalculate(item);
                  let totalPrice = item?.price;
                  if (CheckIsMeal(item?.is_meal)) {
                    addons = TotalPriceOfMealItem(item?.map_order_meal_items)
                  }
                  totalPrice = (addons?.addonsPrice || 0) + item?.price;
                  return (
                    <div
                      key={item.item_name}
                      className="cursor-pointer"
                      onClick={() => handleOrderDetail(order)}
                    >
                      <div className="grid grid-cols-3">
                        <div className="flexBox gap-2 items-center">
                          <h4 className="md:text-lg textMd font-medium">
                            {item?.item_name} {ItemSizeNameForOrder(item)}
                          </h4>
                        </div>
                        <div className="itemSize md:text-lg textMd font-medium text-center">
                          {item?.quantity || 1}x
                        </div>
                        <div className="Price md:text-lg textMd font-medium  text-right">
                          {ParseFloat(totalPrice * (item.quantity || 1))}
                        </div>
                      </div>
                      {addons?.addonsItem ? (
                        <div className="grid grid-cols ms-2 text-[#676767] md:text-lg textMd font-normal my-2">
                          <div className="flex gap-2 items-center capitalize">
                            <i className="fa fa-circle text-[3px]"></i>
                            <p>
                              {addons?.addonsItem || "No Sub Items Added"}{" "}
                                <>({ParseFloat(addons.addonsPrice)})</>
                        
                            </p>
                          </div>
                          {/* <p className="text-center">
                            <div className="itemSize md:text-lg textMd font-medium text-center">
                              {item?.quantity || 1}X
                            </div>
                          </p>
                          <p className="text-right text-black">
                            {ParseFloat(addons.addonsPrice)}
                          </p> */}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
                <div className="cursor-pointer flex justify-between md:flex-row flex-col items-start gap-3">
                  <p className="text-black md:text-lg textMd md:text-left text-center ubermoveTextNormal">
                    {t("MyOrders.orderPlaceOn")}{" "}
                    {moment(order?.updated_at).format("lll")}
                  </p>

                  <div className="flex md:justify-center justify-between md:w-auto w-full">
                    <span className="me-1">
                      <AllReview
                        refrencePage={reviewRefrencePageArr[1]}
                        orderDetail={order}
                      />
                    </span>

                    {/* @@ Store contact details dynamic*/}
                    {order?.store_data &&
                      order?.store_data?.length > 0 &&
                      order?.store_data[0]?.phone_number ? (
                      <>
                        <button
                          onClick={() => setIsNumber(!isNumber)}
                          className=" bg-[#34558B] textMd  text-white px-3 py-0 flex gap-2 items-center"
                        >
                          <i className="fa fa-phone text-xl"></i>
                          <div>
                            {isNumber ? (
                              <p className="font-normal">
                                {order?.store_data[0]?.country_code
                                  ? order?.store_data[0]?.country_code
                                  : null}{" "}
                                {order?.store_data[0]?.phone_number}
                              </p>
                            ) : (
                              <p className="font-bold theme-background-color">{t("MyOrders.callRestaurant")}</p>
                            )}
                          </div>
                        </button>
                      </>
                    ) : null}
                  </div>
                </div>
                {/* @@ Review section */}
                {/* <AllReview refrencePage={reviewRefrencePageArr[1]} orderDetail={order} /> */}
              </div>
            </div>
          ))
        ) : (
          <NoOrderFound content={t("MyOrders.noOrders")} />
        )}
      </div>
    </>
  );
}
